<template>
<div class="wrap_video wow fadeInUp">
<el-row >
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="20" class="header_block" style="background:#fff">
  <!-- <div class="video_tv">VIDEO</div>
   <div class="video_text">宣传视频</div> -->
   <div class="shooting_one wow fadeInUp" ref="shooting_one">
     <img  :src="require('@/assets/imgs/shooting01.jpeg')" ref="shooting_one_img" class="shoot_img"/>
   </div>
   <div v-for="(item,index) in shootingArray" :key="index" :class="item.cName" class="wow fadeInUp">
     <img ref="shooting_img"  :src="item.url" class="shoot_img"/>
   </div>
   </el-col>
  <el-col :span="2" class="header_block"></el-col>
</el-row >
</div>

</template>

<script>
export default {
  name: 'shooting',
  // props: {
  //   videoArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      shootingArray:[ 
        // {url:require('@/assets/imgs/shooting01.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/imgs/shooting02.jpeg'),cName:'shooting_two'},
        {url:require('@/assets/imgs/shooting03.jpeg'),cName:'shooting_three'},
        {url:require('@/assets/imgs/shooting04.jpeg'),cName:'shooting_three'},
        {url:require('@/assets/imgs/shooting05.jpeg'),cName:'shooting_two'},
        {url:require('@/assets/imgs/shooting09.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/imgs/shooting08.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/imgs/shooting07.jpeg'),cName:'shooting_two'},
        {url:require('@/assets/imgs/shooting06.jpeg'),cName:'shooting_three'},
        {url:require('@/assets/imgs/shooting10.jpeg'),cName:'shooting_three'},
        {url:require('@/assets/imgs/shooting11.jpeg'),cName:'shooting_two'},
        {url:require('@/assets/imgs/shooting12.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/imgs/shooting13.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/imgs/shooting14.jpeg'),cName:'shooting_two'},
        {url:require('@/assets/imgs/shooting15.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting16.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting17.jpeg'),cName:'shooting_two'},
        // {url:require('@/assets/imgs/shooting18.jpeg'),cName:'shooting_one'},
      ],
      initHeight:0,
    }
  },
  

  mounted(){
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
    setTimeout(()=>{
 let initHeight = this.$refs.shooting_one.clientHeight
 this.initHeight = Math.ceil(initHeight)
  console.log(initHeight,'1111')
  console.log(this.$refs.shooting_img,'9090')
  for (let i=0;i<this.$refs.shooting_img.length;i++) {
    this.$refs.shooting_img[i].style.height = this.initHeight + 'px'

  }
    },2000)

    setTimeout(()=>{
      console.log(111)
  this.$refs.shooting_one_img.style.height = this.initHeight + 'px'
    },4000)
//     // 图片地址
// var imgURL = '../assets/imgs/shooting01.jpeg'

// // 创建实例对象
// var img = new Image()

// // 图片地址
// img.src = imgURL 

// // 打印
//  console.log('width:'+img.width+',height:'+img.height);
// this.$nextTick(()=>{
//   let initHeight = this.$refs.shooting_one.clientHeight
//   console.log(initHeight,'1111')
// })
    // let initHeight = this.$refs.shooting_one.clientHeight
    // // this.$refs.shooting_img.style.height = initHeight +'px'
    // console.log(initHeight,'1111')
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
	// 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
	// })
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_video{
  .header_block{
    min-height: 10px;
  }
  .shooting_one{
    width: calc((100% - 40px)/3.96*1.78) ;
    margin: 3px 0 0 5px;
    float: left;
  }
  .shooting_two{
    width: calc((100% - 40px)/3.96*1.18) ;
    margin: 3px 0 0 5px;
    float: left;
  }
  .shooting_three{
    width: calc((100% - 40px)/3.96*1) ;
    margin: 3px 0 0 5px;
    float: left;
  }
  .shoot_img{
    width: 100%;

  }
  
  }
</style>



